<template>
	<b-dropdown toggle-class="header-item noti-icon" right menu-class="dropdown-menu-lg p-0" variant="black" no-caret>
		<template v-slot:button-content>
			<i class="bx bx-task"></i>
			<span v-if="notifications.length" class="badge badge-danger badge-pill">{{ notifications.length }}</span>
		</template>

		<div class="p-3">
			<div class="row align-items-center">
				<div class="col">
					<h6 class="m-0">File Jobs</h6>
				</div>
				<div class="col-auto">
					<a href="javascript:void(0)" class="small" @click="clearAllNotifications">Clear All</a>
				</div>
			</div>
		</div>

		<div v-if="notifications.length">
			<simplebar data-simplebar style="max-height: 530px; min-height: 100px; overflow-y: auto;">
				<a v-for="n in notifications" :key="n.id"
					:href="notifiableUrl(n)"
					:target="n.notifiable_type.includes('ExportFile') ? '_blank' : ''"
					class="text-reset notification-item">
					
					<div class="media">
						<div class="avatar-xs mr-3">
							<span class="avatar-title rounded-circle font-size-16" :class="statusColor(n.status)">
								<i :class="statusIcon(n.status)"></i>
							</span>
						</div>
						<div class="media-body">
							<h6 class="mt-0 mb-1">{{ n.type.toUpperCase() }} – {{ n.status }}</h6>
							<div class="font-size-12 text-muted">
								<p class="mb-1">
									{{ n.successful_items }}/{{ n.total_items }} successful
									<span v-if="n.failed_items">({{ n.failed_items }} failed)</span>
									<span v-if="n.file_url"> – <a :href="n.file_url" target="_blank">Download</a></span>
								</p>
								<p class="mb-0">
									<i class="mdi mdi-clock-outline"></i> {{ n.created_at | fromNow }}
								</p>
							</div>
						</div>
						<b-button variant="link" size="sm" class="ml-auto p-0 text-muted" @click.stop="dismiss(n.id)"
							title="Dismiss">
							✕
						</b-button>
					</div>
				</a>
			</simplebar>
		</div>

		<div v-else class="text-center py-3" style="min-height: 100px;">
			No File Jobs
		</div>

		<div class="p-2 border-top">
			<a v-if="!finished" class="btn btn-sm btn-light btn-block text-center" href="javascript:void(0)"
				@click="fetchNotifications">
				<i class="mdi mdi-arrow-down-circle mr-1"></i> Load More..
			</a>
		</div>
	</b-dropdown>
</template>

<script>

import simplebar from "simplebar-vue";

export default {
	name: 'FileNotificationsDropdown',
	components: {
		simplebar
	},
	props:['item_type'],
	data() {
		return {
			notifications: [],
			page: 1,
			perPage: 10,
			loading: false,
			finished: false,
			polling: null
		};
	},
	mounted() {
		this.fetchNotifications();
		this.startPolling();
	},
	beforeDestroy() {
		this.stopPolling();
	},
	methods: {
		notifiableUrl(notification) {
			if (!notification || !notification.notifiable_type || !notification.notifiable_id) {
				return 'javascript:void(0)';
			}

			const type = notification.notifiable_type;
			const id = notification.notifiable_id;

			if (type.includes('ExportFile')) {
				return `/${this.item_type}/files/${id}/open`;
			} else if (type.includes('ImportFile')) {
				return `/${this.item_type}/file_imports/${id}/view`;
			}
			return 'javascript:void(0)';
		},
		async clearAllNotifications() {
			try {
				await axios.post('/api/assetflow/notifications/files/clear-all');
				this.notifications = [];
				this.finished = true; // no more notifications to load
			} catch (error) {
				console.error('Failed to clear notifications:', error);
			}
		},
		fetchNotifications() {
			if (this.loading || this.finished) return;

			this.loading = true;
			axios
				.get('/api/assetflow/notifications/files', {
					params: {
						page: this.page,
						per_page: this.perPage,
					},
				})
				.then((response) => {
					const responseData = response.data || {};
					const newData = responseData.data || [];
					const total = responseData.total || 0;

					// Deduplication
					const existingIds = new Set(this.notifications.map(n => n.id));
					const newNotifications = newData.filter(n => !existingIds.has(n.id));

					if (this.page === 1) {
						this.notifications = newNotifications;
					} else {
						this.notifications.push(...newNotifications);
					}

					if (this.notifications.length >= total) {
						this.finished = true;
					}

					this.page++;
				})
				.catch((error) => {
					console.log('Failed to fetch notifications:', error);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		startPolling() {
			this.polling = setInterval(() => {
				this.refreshNotifications();
			}, 10 * 60 * 1000);
		},
		stopPolling() {
			if (this.polling) clearInterval(this.polling);
		},
		refreshNotifications() {
			// Reset and re-fetch latest
			this.page = 1;
			this.notifications = [];
			this.finished = false;
			this.fetchNotifications();
		},
		dismiss(id) {
			axios
				.post(`/api/assetflow/notifications/files/${id}/dismiss`)
				.then(() => {
					this.notifications = this.notifications.filter((n) => n.id !== id);
				})
				.catch((err) => {
					console.error('Dismiss failed:', err);
				});
		},
		statusIcon(status) {
			switch (status) {
				case 'done':
				case 'completed':
					return 'bx bx-check-circle';
				case 'processing':
				case 'pending':
					return 'bx bx-loader-circle';
				case 'failed':
				case 'error':
					return 'bx bx-error-circle';
				default:
					return 'bx bx-info-circle';
			}
		},
		statusColor(status) {
			switch (status) {
				case 'done':
				case 'completed':
					return 'bg-success';
				case 'processing':
				case 'pending':
					return 'bg-warning';
				case 'failed':
				case 'error':
					return 'bg-danger';
				default:
					return 'bg-info';
			}
		}
	},
};
</script>
